import * as React from "react";
import { Field } from "formik";
import { Form as AntdForm } from "antd";
import { FormItem } from './FormItem';
export function Form(props) {
  return React.createElement(Field, null, function (_ref) {
    var _ref$form = _ref.form,
        handleReset = _ref$form.handleReset,
        handleSubmit = _ref$form.handleSubmit;
    return React.createElement(AntdForm, Object.assign({
      onReset: handleReset,
      onSubmit: handleSubmit
    }, props));
  });
}
;
Form.Item = FormItem;